// File: client/src/components/rules/nodeConfigs/CompleteConfig.js
import React from 'react';
import { Form, Input } from 'antd';

const { TextArea } = Input;

const CompleteConfig = () => {
    return (
        <div>
            <Form.Item
                name="description"
                label="Description"
            >
                <TextArea rows={3} placeholder="Enter description for workflow completion" />
            </Form.Item>
        </div>
    );
};

export default CompleteConfig;
